import Controller from '@ember/controller'
import { tracked } from '@glimmer/tracking'
import moment from 'moment-timezone';

import getConfig from 'beebee-base/lib/get-config';
import {
    clearAttribute
} from 'beebee-base/lib/utility'
import { beebeeAjaxPost, beebeeAjaxGet } from 'beebee-base/lib/utility/ajax';

import {
    action,
    computed,
    get,
    set
} from '@ember/object'

import {
    task,
    timeout
} from 'ember-concurrency'

import {
    inject as iService
} from '@ember/service'

import {
    inject as iController
} from '@ember/controller'

export default class IndexController extends Controller {
    @iService intl
    @iService session
    @iService store
    @iService log

    @iController('application') applicationController

    @tracked dateCalendar = new Date()
    @tracked dateSelected = null

    hidePartecipoIo = false
    add_younger = false

    //hourSelected = true
    people = [
        /*{
                'first_name': null,
                'id': null,
                'last_name': null,
                'data_nascita': null
            }*/
    ]

    selectedTimeZone = moment.tz.guess()
    timeZoneLists = moment.tz.names()

    get showCreaAccount() {
        if (this.session.me?.id) {
            return false
        }

        if (this.session.option_field?.booking_settings?.not_require_password) {
            return false
        }

        return true
    }

    @computed('session.option_field.booking_settings.operatore_first')
    get operatoreFirst() {
        if (get(this, 'session.option_field.booking_settings.operatore_first')) {
            return get(this, 'session.option_field.booking_settings.operatore_first')
        }

        return false
    }

    @computed('dateCalendar')
    get currentMonth() {
        return moment(this.dateCalendar).format('MMMM')
    }

    @computed('dateCalendar')
    get isNotCurrentMonth() {
        return !moment(this.dateCalendar).isSame(moment(), 'month')
    }


    @computed('this.session.openOrganization.thumbnail_url', 'urlData')
    get thumbnail_url() {
        if (get(this, 'session.openOrganization.thumbnail_url')) {
            return `${this.urlData}/${get(this, 'session.openOrganization.thumbnail_url')}-medium.jpeg`
        }
        return 'https://beebeeassets.beebeeboard.com/assets/img/logo.png'
    }

    // Was a getter-only @computed; `set(this,'payment', ...)` in the booking-confirm
    // task threw "read-only" (swallowed by the surrounding try), so the real payment
    // record never landed and showPayment was never reached. Now a tracked field,
    // seeded with the same placeholder default in the constructor.
    @tracked payment;

    constructor() {
        super(...arguments);
        this.payment = this.store.createRecord('payment', {
            'total': 100,
            'id': 1,
            'success': false
        });
    }

    _emptyContact = null;

    get me() {
        if (this.session.me?.id) {
            return this.session.me;
        }

        if (!this._emptyContact || this._emptyContact.isDestroyed || this._emptyContact.isDestroying) {
            this._emptyContact = this.store.createRecord('contact');
            this._emptyContact.get('addresses').push(this.store.createRecord('address', {
                'is_invoice': true,
                'location_address_country': 'Italia',
                'location_address_country_code': 'IT'
            }));
        }

        return this._emptyContact;
    }

    @computed('contact', 'dispos.contacts.[]').readOnly()
    get contactSelected() {
        if (this.dispos && Array.isArray(this.dispos.contacts)) {
            return this.dispos.contacts.filter(item => item.id === parseInt(this.contact))[0]
        }
        return null
    }

    @computed('product', 'dispos.products.[]').readOnly()
    get productSelected() {
        if (this.dispos && Array.isArray(this.dispos.products)) {
            return this.dispos.products.filter(item => item.id === parseInt(this.product))[0]
        }
        return null
    }

    @computed('category', 'dispos.product_categories.[]').readOnly()
    get categorySelected() {
        if (this.dispos && Array.isArray(this.dispos.product_categories)) {
            return this.dispos.product_categories.filter(item => item.id === parseInt(this.category))[0]
        }
        return null
    }

    @computed('dispos.product_categories.length').readOnly()
    get skipStep0() {
        if(this.dispos?.product_categories?.length) {
            return false
        }

        return true;
    }

    @computed('operatoreFirst').readOnly()
    get skipStep1() {
        if(this.operatoreFirst) {
            const skipSelectContact = get(this, 'session.option_field.booking_settings.skip_contact') || false
            return skipSelectContact ? true : false
        }

        const skipSelectProduct = get(this, 'session.option_field.booking_settings.skip_product') || false
        return skipSelectProduct ? true : false
    }

    @computed('operatoreFirst').readOnly()
    get skipStep2() {
        if(this.operatoreFirst) {
            const skipSelectProduct = get(this, 'session.option_field.booking_settings.skip_product') || false
            return skipSelectProduct ? true : false
        }

        const skipSelectContact = get(this, 'session.option_field.booking_settings.skip_contact') || false
        return skipSelectContact ? true : false
    }

    @computed('skipStep0', 'categorySelected.id').readOnly()
    get step0() {
        if(this.skipStep0 || this.categorySelected) {
            return true
        }

        return false
    }

    @computed('operatoreFirst', 'productSelected.id', 'contactSelected.id', 'step0').readOnly()
    get step1() {
        if(this.contact && this.product) {
            return true
        }

        if(!this.step0 && !this.skipStep0) {
            return false
        }

        if(this.operatoreFirst) {
            const skipSelectContact = get(this, 'session.option_field.booking_settings.skip_contact') || false
            return (this.contactSelected || skipSelectContact) ? true : false
        }

        const skipSelectProduct = get(this, 'session.option_field.booking_settings.skip_product') || false
        return (this.productSelected || skipSelectProduct) ? true : false
    }

    @computed('operatoreFirst', 'contactSelected.id', 'productSelected.id', 'step1').readOnly()
    get step2() {
        if(!this.step1) {
            return false
        }

        if(this.operatoreFirst) {
            const skipSelectProduct = get(this, 'session.option_field.booking_settings.skip_product') || false
            return (this.productSelected || skipSelectProduct) ? true : false
        }

        const skipSelectContact = get(this, 'session.option_field.booking_settings.skip_contact') || false
        return (this.contactSelected || skipSelectContact) ? true : false
    }

    @computed('step2', 'dateSelected', 'hourSelected').readOnly()
    get step3() {
        if(!this.step2) {
            return false
        }

        return (this.dateSelected && this.hourSelected) ? true : false
    }

    @computed('step3').readOnly()
    get step4() {
        return this.step3 ? true : false
    }

    @computed('step0').readOnly()
    get step0Running() {
        return !this.step0
    }

    @computed('step0', 'step1', 'skipStep0').readOnly()
    get step1Running() {
        const step0 = this.step0 || this.skipStep0
        return this.step0 && !this.step1
    }

    @computed('step1', 'step2').readOnly()
    get step2Running() {
        const isStep = this.step1 && !this.step2
        return isStep
    }

    @computed('step2', 'step3').readOnly()
    get step3Running() {
        const isStep = this.step2 && !this.step3

        if (isStep && !this.dispos_slot) {
            get(this, 'updateMonthTask').perform(this.dateCalendar ? this.dateCalendar : new Date())
        }

        if (isStep) {
            set(this, 'bookConfirmed', false)
        }

        return isStep
    }

    @computed('productSelected.id', 'dispos.contacts.[]', 'categorySelected.id').readOnly()
    get contactsFiltered() {
        var self = this

        if (this.dispos && Array.isArray(this.dispos.contacts)) {
            let contacts = [...this.dispos.contacts];

            contacts.forEach((c) => { c.push = false; });
            if(this.categorySelected?.id && Array.isArray(this.dispos.products)) {
                const cEnable = [];

                for(let i = 0; i < contacts.length; i++) {
                    if(Array.isArray(contacts[i]?.products)) {

                        for(let j = 0; j < contacts[i].products.length; j++) {
                            const product = this.dispos.products.filter(item => item.id === contacts[i].products[j]);

                            if(product.length) {
                                const isPresent = product.filter(function(p) {
                                    return Array.isArray(p.category_ids) ? p.category_ids.indexOf(self.categorySelected.id) !== -1 : false
                                })

                                if(isPresent.length && !contacts[i].push) {
                                    cEnable.push(contacts[i]);
                                    contacts[i].push = true;
                                }
                            }
                        }
                    }
                }

                contacts = cEnable;
            }

            if (!this.productSelected) {
                return contacts
            }

            const contactsFilter = contacts.filter(function(p) {
                return Array.isArray(p.products) ? p.products.indexOf(self.productSelected.id) !== -1 : false
            })

            for(let i = 0; i < contactsFilter.length; i++) {
                const productObjSelect = contactsFilter[i].product_objs.filter(item => item.id === self.productSelected.id);

                if(productObjSelect.length && productObjSelect[0]?.first_dispo) {
                    const dispo = productObjSelect[0].first_dispo.split(' @ ');
                    contactsFilter[i].first_dispo = dispo[0];
                    contactsFilter[i].stanza = dispo[1];
                }
            }

            return contactsFilter;
        }

        return []
    }

    @computed('contactSelected.id', 'dispos.[]', 'categorySelected.id').readOnly()
    get productsFiltered() {
        var self = this

        if (this.dispos && Array.isArray(this.dispos.products)) {
            let products = this.dispos.products;

            if(this.categorySelected?.id) {
                products = products.filter(function(p) {
                    return Array.isArray(p.category_ids) ? p.category_ids.indexOf(self.categorySelected.id) !== -1 : false
                })
            }

            if (!this.contactSelected) {
                return products
            }

            const productsFilter = products.filter(function(p) {
                return Array.isArray(p.contacts) ? p.contacts.indexOf(self.contactSelected.id) !== -1 : false
            })

            for(let i = 0; i < productsFilter.length; i++) {
                const contactObjSelect = productsFilter[i].contact_objs.filter(item => item.id === self.contactSelected.id);

                if(contactObjSelect.length && contactObjSelect[0]?.first_dispo) {
                    const dispo = contactObjSelect[0].first_dispo.split(' @ ');
                    productsFilter[i].first_dispo = dispo[0];
                    productsFilter[i].stanza = dispo[1];
                }
            }

            return productsFilter;

        }

        return []
    }

    @action
    setCategory(c, e) {
        set(this, 'category', c.id)
        this.scrollTop()
    }

    @action
    setContact(c, e) {
        if(this.operatoreFirst) {
            if (Array.isArray(this.dispos.products) && this.dispos.products.length === 1) {
                set(this, 'product', this.dispos.products[0].id);
            } else {
                set(this, 'product', null);
            }
        }

        set(this, 'contact', (this.contactSelected && this.contactSelected.id === c.id) ? null : c.id)

        this.scrollTop()
    }

    @action
    setProduct(p, e) {
        if(!this.operatoreFirst) {
            if (Array.isArray(this.dispos.contacts) && this.dispos.contacts.length === 1) {
                set(this, 'contact', this.dispos.contacts[0].id);
            } else {
                set(this, 'contact', null);
            }
        }

        set(this, 'product', (this.productSelected && this.productSelected.id === p.id) ? null : p.id)

        this.scrollTop()
    }

    @action addOnlyPerson(add_younger = false) {

        set(this, 'add_younger', add_younger)

        if (!add_younger || !Array.isArray(this.people)) {
            set(this, 'people', [])
        }

        if(add_younger) {
            set(this, 'people', [...this.people, {
                'first_name': null,
                'id': null,
                'last_name': null,
                'mobile':  null,
                'data_nascita': null,
            }])
        }
    }

    @action addPerson(me) {
        this.addPerson(me)
    }

    addPerson(me) {

        if(!this.session.option_field.booking_settings.show_people ||
            this.session.option_field.booking_settings.hide_people) {
            return;
        }

        const p = {
            'first_name': me ? get(me, 'first_name') : null,
            'id': me ? get(me, 'id') : null,
            'same': me ? true : false,
            'lock_first_name': (me && get(me, 'first_name')) ? true : false,
            'lock_last_name': (me && get(me, 'last_name')) ? true : false,
            'last_name': me ? get(me, 'last_name') : null,
            'mobile': me ? get(me, 'mobile') : null,
            'data_nascita': me ? get(me, 'data_nascita') : null,
        }

        if(me) {
            set(this, 'hidePartecipoIo', true)
        }

        if (!Array.isArray(this.people) || (me && this.people.length === 1)) {
            set(this, 'people', [])
        }

        set(this, 'people', [...this.people, p])
    }

    @computed('hourSelected.rimanenti', 'people.length', 'this.hourSelected.rimanenti')
    get canAddPerson() {
        if (this.hourSelected && this.hourSelected.rimanenti && this.people.length >= this.hourSelected.rimanenti) {
            return false
        }

        return true
    }

    @computed('people.length', 'productSelected.{prezzo_a_persona,price}')
    get totalPrice() {
        if (this.productSelected?.prezzo_a_persona) {
            return this.productSelected.price * this.people.length
        }

        return this.productSelected?.price || null
    }

    @action delPerson(person) {
        if (Array.isArray(this.people)) {
            set(this, 'people', this.people.filter((i) => i !== person))
            set(this, 'hidePartecipoIo', false)
        }
    }

    @(task(function* ({
        date,
        rec_number,
        stop_search
    }) {
        try {
          this.dateCalendar = date

          document.querySelectorAll('button.ember-power-calendar-day').forEach((el) => {
              el.setAttribute('available', false)
          })

          yield timeout(250)

          const momentDate = moment(date)
          const dispos = yield beebeeAjaxGet(
              `${getConfig(this).APP.urlApi}/dispos${this.productSelected?.is_group ? '_groups' : ''}`,
              null,
              {
                  'contact_id': this.contactSelected ? this.contactSelected.id : null,
                  'product_id': this.productSelected ? this.productSelected.id : null,
                  'from_date': momentDate.startOf('month').tz(this.selectedTimeZone).format('YYYY-MM-DDTHH:mmZ'),
                  'to_date': momentDate.endOf('month').tz(this.selectedTimeZone).format('YYYY-MM-DDTHH:mmZ')
              }
          )

          let noDispoAvailable = true
          if (Array.isArray(dispos.giorni_array)) {
              noDispoAvailable = false
              for (let i = 0; i < dispos.giorni_array.length; i++) {
                  document.querySelectorAll(`button.ember-power-calendar-day[data-date='${dispos.giorni_array[i]}']`).forEach((el) => {
                      el.setAttribute('available', true)
                  })
              }
          } else if (!stop_search && (!rec_number || rec_number < 3)) {
              const dateN = this.dateCalendar ? this.dateCalendar : new Date
              yield this.updateMonthTask.perform({
                  'date': new Date(dateN.getFullYear(), dateN.getMonth() + 1, 1),
                  'rec_number': rec_number ? ++rec_number : 1
              })
          }

          set(this, 'noDispoAvailable', noDispoAvailable)
          set(this, 'dispos_slot', dispos)
        } catch (e) {
          // Left uncaught, a 4xx/network failure here surfaced as a Sentry
          // unhandled rejection. Background loader: log only, no notify.
          this.log.warn('updateMonthTask: /dispos failed', e)
        }

    }).restartable()) updateMonthTask

    @(task(function* () {
        var self = this

        let emptyRequiredField = false
        const bookErrorArr = []
        set(this, 'bookError', null)
        set(this, 'requiredEmpty', {})

        if (Array.isArray(this.applicationController.gdprField.organization_term_options.data)) {
            this.applicationController.gdprField.organization_term_options.data.forEach(function(ogt) {
                set(ogt, 'error', false)
                if (ogt.registration && ogt.required && !ogt.selected) {
                    emptyRequiredField = true
                    set(ogt, 'error', true)
                }
            })
        }

        let me = get(this, 'me')

        if (get(me, 'id')) {
            me = get(this, 'store').peekRecord('contact', get(me, 'id'))
        }
        me.eachAttribute(function(name) {
            set(me, name, clearAttribute(get(me, name)))
        })

        if (!get(me, 'fisica_giuridica') && !get(me, 'last_name')) {
            set(this, 'requiredEmpty.last_name', true)
            emptyRequiredField = true
        }

        if (!get(me, 'fisica_giuridica') && !get(me, 'first_name')) {
            set(this, 'requiredEmpty.first_name', true)
            emptyRequiredField = true
        }

        if (get(me, 'fisica_giuridica') && !get(me, 'ragione_sociale')) {
            set(this, 'requiredEmpty.ragione_sociale', true)
            emptyRequiredField = true
        }

        var validateEmail = function(email) {
            var re = /\S+@\S+\.\S+/
            return re.test(email)
        }

        if (!get(me, 'mail') || !validateEmail(get(me, 'mail'))) {
            set(this, 'requiredEmpty.mail', true)
            emptyRequiredField = true
        }

        if (!get(me, 'mobile')) {
            set(this, 'requiredEmpty.mobile', true)
            emptyRequiredField = true
        }

        if (!this.session.option_field.booking_settings.not_require_password === true &&
            !get(me, 'id') && !get(me, 'password')) {
            set(this, 'requiredEmpty.password', true)
            emptyRequiredField = true
        }

        if (get(this, 'session.option_field.booking_settings.payment_required')) {
            if (!get(me, 'cod_fiscale')) {
          set(this, 'requiredEmpty.cod_fiscale', true)
          emptyRequiredField = true
            }

            if (get(me, 'fisica_giuridica') && !get(me, 'piva')) {
          set(this, 'requiredEmpty.piva', true)
          emptyRequiredField = true
            }

            const addresses = get(me, 'addresses');
            const address = addresses?.[0];
            if (
              !address?.location_address_street ||
              !address?.location_address_house ||
              !address?.location_address_postal_code ||
              !address?.location_address_city ||
              !address?.location_address_country
            ) {
              set(this, 'requiredEmpty.addresses', true)
              emptyRequiredField = true
            }
        }

        if (!this.session.option_field.booking_settings.hide_people &&
            this.session.option_field.booking_settings.show_people &&
            (!Array.isArray(this.people) || this.people.length === 0)) {
            set(this, 'requiredEmpty.people', true)
            emptyRequiredField = true
        }

        if (!this.session.option_field.booking_settings.hide_people &&
            Array.isArray(this.people)) {
            this.people.forEach(function(p) {
                set(p, 'requiredEmpty', {})

                set(p, 'first_name', clearAttribute(p.first_name))
                set(p, 'last_name', clearAttribute(p.last_name))
                set(p, 'data_nascita', clearAttribute(p.data_nascita))

                if (!p.first_name) {
                    set(p, 'requiredEmpty.first_name', true)
                    emptyRequiredField = true
                }

                if (!p.last_name) {
                    set(p, 'requiredEmpty.last_name', true)
                    emptyRequiredField = true
                }

                if (!p.data_nascita) {
                    set(p, 'requiredEmpty.data_nascita', true)
                    emptyRequiredField = true
                } else {
                    const years = moment().diff(p.data_nascita, 'years')

                    if (self.productSelected && self.productSelected.min_age && self.productSelected.min_age > years) {
                        set(p, 'requiredEmpty.data_nascita', true)
                        emptyRequiredField = true
                        bookErrorArr.push({
                            'detail': `${self.intl.t('error min age')}, min ${self.productSelected.min_age} ${self.intl.t('years')}`
                        })
                    }

                    if (self.productSelected && self.productSelected.max_age && self.productSelected.max_age < years) {
                        set(p, 'requiredEmpty.data_nascita', true)
                        emptyRequiredField = true
                        bookErrorArr.push({
                            'detail': `${self.intl.t('error max age')}, max ${self.productSelected.max_age} ${self.intl.t('years')}`
                        })
                    }
                }
            })
        }

        if (emptyRequiredField) {
            set(this, 'bookError', {
                'errors': [{
                        'detail': this.intl.t('empty required field')
                    },
                    ...bookErrorArr
                ]
            })
            return
        }

        try {
            const addresses = get(this, 'me.addresses');
            const address = addresses && addresses.length ? addresses[0] : null;

            const confirm = yield beebeeAjaxPost(
              `${getConfig(this).APP.urlApi}/confirm_booking`,
              null,
              {
                'contact_id': this.contactSelected ? this.contactSelected.id : null,
                'contact_name': this.contactSelected ? this.contactSelected.name : null,
                'contact_mail': this.contactSelected ? this.contactSelected.mail : null,
                'product_id': this.productSelected ? this.productSelected.id : null,
                'product_name': this.productSelected ? this.productSelected.name : null,
                'first_name': get(this, 'me.first_name'),
                'last_name': get(this, 'me.last_name'),
                'password': get(this, 'me.password'),
                'piva': get(this, 'me.piva'),
                'ragione_sociale': get(this, 'me.ragione_sociale'),
                'fisica_giuridica': get(this, 'me.fisica_giuridica'),
                'mobile': get(this, 'me.mobile'),
                'mail': get(this, 'me.mail'),
                'cod_fiscale': get(this, 'me.cod_fiscale'),
                'location_address_street': address ? get(address, 'location_address_street') : null,
                'location_address_house': address ? get(address, 'location_address_house') : null,
                'location_address_postal_code': address ? get(address, 'location_address_postal_code') : null,
                'location_address_city': address ? get(address, 'location_address_city') : null,
                'location_address_country': address ? get(address, 'location_address_country') : null,
                'location_address_country_code': address ? get(address, 'location_address_country_code') : null,
                'user_id': get(this, 'session.me.id'),
                'event_group_id': this.productSelected.is_group ? this.hourSelected.id : null,
                'from_date': moment(this.hourSelected.start).tz(this.selectedTimeZone).format('YYYY-MM-DDTHH:mmZ'),
                'to_date': moment(this.hourSelected.end).tz(this.selectedTimeZone).format('YYYY-MM-DDTHH:mmZ'),
                'stanza_id': this.hourSelected.stanza_id || null,
                'people': this.people,
                'organization_term_options': this.applicationController.gdprField.organization_term_options,
                'organization_name': get(this, 'session.openOrganization.name'),
                'thumbnail_url': get(this, 'session.openOrganization.thumbnail_url'),
                'primary_color': get(this, 'session.openOrganization.primary_color'),
                'lang': this.intl.primaryLocale
              }
            )

            if (confirm.id === 0 || confirm.id === '0') {
                // The booking is already accepted by the backend at this point.
                // An unguarded gtag() (absent whenever the analytics snippet is
                // blocked or stripped) threw a ReferenceError into the catch
                // below, which sets bookError = e.responseJSON — undefined on a
                // ReferenceError — so the customer got neither the confirmation
                // nor an error and would book a second time. Same guard as
                // app/controllers/checkout.js:533.
                if (typeof gtag === 'function') {
                    gtag('event', 'purchase', {
                        'event_category': 'ecommerce',
                        'event_label': this.productSelected,
                        'send_to': 'G-Q4R8QL4WC0'
                    });
                }

                if (Array.isArray(window.dataLayer)) {
                  window.dataLayer.push({
                    event: 'purchase',
                    ecommerce: {
                      items: [
                        {
                          item_id: this.productSelected ? this.productSelected.id : null,
                          item_name: this.productSelected ? this.productSelected.name : null,
                          price: this.productSelected ? this.productSelected.price : null,
                        }
                      ]
                    }
                  });
                }

                set(this, 'bookConfirmed', true)
            } else {
                this.session.authenticate(confirm.token)
                yield timeout(50)
                yield this.session.reloadMeTask.perform();

                const payment = yield get(this, 'store').findRecord('payment', confirm.id, {
                    'reload': true
                })

                set(this, 'request_by', confirm.payment_user_id)
                set(this, 'payment', payment)
                set(this, 'showPayment', true)
            }
        } catch (e) {
            if(e.responseJSON?.errors?.[0]?.title === 'Utente già esistente') {
                e.responseJSON.errors.push({
                    detail: 'Accedi per completare la prenotazione'
                })
            }
            set(this, 'bookError', e.responseJSON)
        }
    }).drop()) confirmBookingTask

    @action
    nextMonth() {
        const date = this.dateCalendar ? this.dateCalendar : new Date

        this.updateMonthTask.perform({
            'date': new Date(date.setMonth(date.getMonth() + 1))
        })
    }

    @action
    goCurrentMonth() {
        this.updateMonthTask.perform({
            'date': new Date(),
            'stop_search': true
        })
    }

    @action
    updateDay(date) {
        this.dateSelected = date

        if (get(this, 'dispos_slot.giorni')) {
            const slots = get(this, 'dispos_slot.giorni')[moment(date).tz(this.selectedTimeZone).format('YYYY-MM-DD')]
            set(this, 'slots', slots)
        } else {
            set(this, 'slots', null)
        }
    }

    @action
    confirmBooking(event) {
        get(this, 'confirmBookingTask').perform()
        event.preventDefault()
    }

    @action
    setDateHour(hour) {
        if (!hour.busy) {
            set(this, 'hourSelected', hour)
            // Advancing to step 4: reveal the "partecipo io" option (was previously
            // toggled as a side-effect inside the step4 getter).
            set(this, 'hidePartecipoIo', false)

            this.scrollTop()

            if (this.me && this.session.option_field.booking_settings.show_people) {
                this.addPerson(this.me)
            }
        }
    }

    @action
    clickStep0() {
        set(this, 'category', null)
        set(this, 'contact', null)
        set(this, 'product', null)
        this.baseReset()
    }

    @action
    clickStep1() {
        if(get(this, 'session.option_field.booking_settings.step1_disable')) {
            return;
        }

         set(this, 'contact', null)
        set(this, 'product', null)
        this.baseReset()
    }

    @action
    clickStep2() {
        if(get(this, 'session.option_field.booking_settings.step2_disable')) {
            return;
        }

        if(this.operatoreFirst) {
            if(get(this, 'session.option_field.booking_settings.skip_product')) {
                set(this, 'contact', null);
            } else {
                set(this, 'product', null)
            }
        } else {
            if(get(this, 'session.option_field.booking_settings.skip_contact')) {
                set(this, 'product', null);
            } else {
                set(this, 'contact', null)
            }
        }

        this.baseReset()
    }

    @action
    clickStep3() {
        this.baseReset()
    }

    @action
    backCalendar() {
        set(this, 'contact', null)
        set(this, 'product', null)
        this.baseReset()
    }

    scrollTop() {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    baseReset() {
        set(this, 'dateSelected', null)
        set(this, 'hourSelected', null)
        set(this, 'dispos_slot', null)
        set(this, 'showPayment', null)
        set(this, 'bookError', null)
    }

    figureOutLocale() {
        const locale = this.calculateLocale(this.intl.get('locales'))
        return locale
    }

    calculateLocale(locales) {
        const language = navigator.languages[0] || navigator.language || navigator.userLanguage
        return locales.includes(language.toLowerCase()) ? language : 'it-IT'
    }

    @(task(function* (lang = null) {
        yield timeout(50)
        const locale = lang ? lang : this.figureOutLocale()

        yield this.intl.loadTranslations(locale)
        get(this, 'intl').set('locale', locale)
        moment.locale(locale)
    }).restartable()) switchLangTask

    @action
    switchLang(lang, e) {
        get(this, 'switchLangTask').perform(lang)
        e.preventDefault()
    }

    destroyRecord(record, redirect_url, notifyUser = true) {
        var self = this,
            id = get(record, 'id')

        if (!record || get(record, 'currentState.stateName') === 'root.deleted.saved') {
            set(self, 'operationDestroy', id)
            return new Promise(function(resolve /*, reject*/ ) {
                resolve(record)
            })

        } else if (!get(record, 'id')) {
            set(self, 'operationDestroy', id)
            return record.deleteRecord()
        }

        return record.destroyRecord().then(function() {
            return true
        }, function(reason) {
            return false
        })
    }
}
